<template>
	<div class="scroll-to-top" v-if="showButton" @click="scrollToTop">
	<span class="material-symbols-outlined">
		<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z"/></svg>
	</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showButton: false,
		};
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		handleScroll() {
			// Adjust the scrollThreshold value as needed
			const scrollThreshold = 300; // Example: Show button after scrolling 300 pixels

			if (window.scrollY > scrollThreshold) {
				this.showButton = true;
			} else {
				this.showButton = false;
			}
		},
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: "smooth" });
		},
	},
};
</script>

<style scoped>
.scroll-to-top {
	position: fixed;
	bottom: 80px;
	right: 30px;
	background-color: #ff3d00;
	color: #fff;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background-color 0.3s;
	z-index: 999;
}

.scroll-to-top:hover {
	background-color: #20202c;
}

.mdi {
	font-size: 24px;
}
</style>
